<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="퀵빌더 설문 내용 목록"
      desc="">
    </admin-filter>

    <div class="btn-group-justify-end">
      <button @click="downloadSurvey"
              class="button" style="width:120px">설문내역 다운로드</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1500"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="created_time" slot-scope="props">
        {{ datesFormat(props.item.created_time, 'date_4') }}
      </div>
      <div slot="route" slot-scope="props" v-if="props.item.form.length>0">
        <span v-for="(item, idx) in props.item.form[0].answer" :key="`item-${idx}`">
          {{ item }}
          <span v-if="idx<props.item.form[0].answer.length-1">,</span>
        </span>
      </div>
      <div slot="keyword" slot-scope="props" v-if="props.item.form.length>1">
        {{ props.item.form[1].answer }}
      </div>
      <div slot="portal" slot-scope="props" v-if="props.item.form.length>2">
        <span v-for="(item2, idx2) in props.item.form[2].answer" :key="`item-${idx2}`">
          {{ item2 }}
          <span v-if="idx2<props.item.form[2].answer.length-1">,</span>
        </span>
      </div>
      <div slot="name" slot-scope="props">{{ props.item.user.name }}</div>
      <div slot="email" slot-scope="props">{{ props.item.user.email }}</div>
      <div slot="phone" slot-scope="props">{{ props.item.user.phone }}</div>
    </admin-table>
  </div>
</template>
<script>
  import ListMixin from "@/mixins/ListMixin";

  export default {
    name: "Survey",
    mixins: [
      ListMixin
    ],
    created() {
      this.initializing('launchpack_builder_survey', 'launchpack/builder/survey');
    },
    data() {
      return {}
    },
    methods: {
      getDataFromServer() {
        this.getData();
      },
      downloadSurvey() {
        this.$axios.get('admin/launchpack/builder/survey/download', {
          params: this.filtered
        }).then(res=>{
          location.href=res.data.file;
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
</style>
